import React from "react";

import LetterDialog, { LetterDialogActions, letterModalBodyClass } from "../UX/LetterDialog";

function DeleteLetterModal({ open = true, onClose, onConfirm }) {
  return (
    <LetterDialog
      open={open}
      onClose={onClose}
      centered
      animationVariant="scaleFade"
      title="Supprimer cette lettre ?"
      footer={
        <LetterDialogActions
          secondaryLabel="Supprimer définitivement"
          onSecondary={onConfirm}
          secondaryVariant="outline-red"
          primaryLabel="Annuler"
          onPrimary={onClose}
          primaryVariant="green"
        />
      }
    >
      <p className={`${letterModalBodyClass} text-center`}>
        La lettre sera définitivement supprimée. Les timbres des destinataires
        ajoutés te seront restitués immédiatement.
      </p>
    </LetterDialog>
  );
}

export default DeleteLetterModal;
